import React, { useRef } from 'react';
import { testimonials } from '../data/site';
import { useGSAP, gsap, MOTION_OK, revealOnScroll } from '../lib/gsap';

// Uma citação em destaque + as demais em faixa com scroll-snap horizontal.
const Testimonials = () => {
  const scope = useRef(null);
  const [featured, ...rest] = testimonials;

  useGSAP(() => gsap.matchMedia().add(MOTION_OK, () => revealOnScroll()), { scope });

  return (
    <section id="depoimentos" ref={scope} data-testid="testimonials-section" className="px-4 py-20 md:px-8 md:py-28">
      <div className="mx-auto max-w-7xl">
        <figure className="max-w-4xl" data-reveal>
          <blockquote className="font-display text-3xl font-semibold leading-[1.15] tracking-tight md:text-5xl">
            “{featured.text}”
          </blockquote>
          <figcaption className="mt-6 text-base">
            <span className="font-semibold">{featured.author}</span>
            {featured.role && <span className="text-soft">, {featured.role}</span>}
          </figcaption>
        </figure>

        <div
          className="-mx-4 mt-14 flex snap-x snap-mandatory gap-4 overflow-x-auto px-4 pb-2 md:mx-0 md:grid md:grid-cols-4 md:overflow-visible md:px-0"
          data-reveal
        >
          {rest.map((t, i) => (
            <figure key={t.text} className="w-[78%] shrink-0 snap-start rounded-2xl border border-line p-6 md:w-auto" data-testid={`testimonial-card-${i}`}>
              <blockquote className="leading-relaxed">“{t.text}”</blockquote>
              <figcaption className="mt-4 text-sm text-soft">{t.author}</figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
